import styled from 'styled-components';
import { Box, Heading, Image, Stack, Text } from '@chakra-ui/react';
import { ReactComponent as iconGo} from "../../../assets/icons/icon-go.svg";
import imgContent from "../../../assets/images/content/bg/content-info.png";
import tContent from "../../../assets/images/content/bg/content-tablet-info.png";
import mContent from "../../../assets/images/content/bg/content-mobile-info.png";

import { InfoHistoryList, OfficeList } from '../../../assets/datas/ConstantLists';
import { useContext, useEffect, useState } from 'react';
import { ReactComponent as iconLogo } from "../../../assets/icons/tbell-logo.svg";
import { ReactComponent as iconPhone } from "../../../assets/icons/icon-phone.svg";
import { ReactComponent as iconMail } from "../../../assets/icons/icon-mail.svg";
import { ScreenContext } from '../../../components/ScreenProvider';
import VerticalScrollSection from '../../../components/VerticalScrollSection';
import VerticalWheelSection from '../../../components/VerticalWheelSection';
import { convertFontSize } from '../../../components/Util';
import TestWheelSection from '../../../components/WheelSection1';
import WheelScrollSection from '../../../components/WheelScrollSection';
import WheelScrollSection2 from '../../../components/WheelScrollSection2';
import WheelScrollSection3 from '../../../components/WheelScrollSection3';

//fill="#BBBBBB" fill-opacity="0.733333" #151515 on
const Info = styled.div`
  width: 100%;
  background: #ffffff;
`;

const Container = styled.div`
  width: 100%;
`;

const IconNext = styled(iconGo)`
  height: 2vw;
  margin-left: 2vw;
  stroke: #121212;
`;

const ImgLogo = styled(iconLogo)`
  width: 100px;
  height: 40px;
  fill: #ff4343;
  background: #ffffff;
  padding: 10px;
  border: 2px solid #ff4343;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    background: #EFEFEF;
  }
`;

const IPhone = styled(iconPhone)<{ $isselect: string }>`
  height: 20px ;
  margin-right: 5px;
  fill: ${(props) => props.$isselect === "true" ? "#151515" : "#BBBBBB"};
`;

const IMail = styled(iconMail)<{ $isselect: string }>`
height: 20px ;
  margin-right: 5px;
  fill: ${(props) => props.$isselect === "true" ? "#151515" : "#BBBBBB"};
`;

const Information = () => {
  const screen = useContext(ScreenContext).style;
  const contents = {
    pc: imgContent,
    mobile: mContent,
    tablet: tContent,
  };

  const historyList = InfoHistoryList;
  const [yearList, setYearList] = useState<number[]>();
  const [dataList, setDataList] = useState<number[]>();

  const setHistoryItemList = () => {
    const years = [];
    const datas = [];
    for(const history of historyList) {
      for(const data of history.datas) {
        datas.push({
          ...data,
          year: history.year
        });
      }
      years.push(history.year);
    }
    setYearList(years);
    setDataList(datas);
  };

  const mapList = OfficeList;
  const [mapId, setMapId] = useState<number>(0);
  const [kakaomap, setKakaoMap] = useState<any>(null);
  const [kakaomarker, setKakaoMarker] = useState<any>(null);


  const initMap = () => {
    const item = mapList[0];
    const container = document.getElementById('map'); //지도를 담을 영역의 DOM 레퍼런스
    const options = { //지도를 생성할 때 필요한 기본 옵션
      center: new window.kakao.maps.LatLng(item.lat, item.lng), //지도의 중심좌표.
      level: 3, //지도의 레벨(확대, 축소 정도)
    };
    const map = new window.kakao.maps.Map(container, options); //지도 생성 및 객체 리턴  
    setKakaoMap(map);
    const marker = new window.kakao.maps.Marker({
      position: new window.kakao.maps.LatLng(item.lat, item.lng), // 마커 위치
      title: `TBELL (${item.name})`,
    });
    setKakaoMarker(marker);
    // 지도에 마커 추가
    marker.setMap(map);
  };

  const updateMap = (item: any) => {
    if(kakaomap) {
      kakaomarker.setMap(null);
      const options = new window.kakao.maps.LatLng(item.lat, item.lng); //지도의 중심좌표.
      kakaomap.setCenter(options);
      kakaomap.setLevel(3);

      const marker = new window.kakao.maps.Marker({
        position: new window.kakao.maps.LatLng(item.lat, item.lng), // 마커 위치
        title: `TBELL (${item.name})`,
      });
      // 지도에 마커 추가
      marker.setMap(kakaomap);
      setKakaoMarker(marker);
    }
  };

  const _setMapId = (id: number) => {
    setMapId(id);
  };

  useEffect(() => {
    updateMap(mapList[mapId]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapId]);

  const handleMove = (e) => {
    if(!kakaomap) return;
    const item = mapList[mapId];
    const options = new window.kakao.maps.LatLng(item.lat, item.lng); //지도의 중심좌표.
    kakaomap.setCenter(options);
    kakaomap.setLevel(3);
  };

  useEffect(() => {
    setHistoryItemList();
    initMap();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Info id={"info"} onScroll={(e) => {}}>
      <Container style={{ marginBottom: "100px" }}>
        <Image 
          src={contents[screen]} 
          w={"100%"} 
          alt="" 
        />
      </Container>
      <Container>
        {screen === "pc" ?
          <>
            <WheelScrollSection2 years={yearList} datas={dataList} history={historyList}/>
            {/* <VerticalWheelSection years={yearList} datas={dataList} /> */}
          </>
        :
          <VerticalScrollSection datas={historyList}/>
        }
      </Container>
      <Container 
        style={{ 
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "5%",
          flexDirection: "column",
          height: "auto" 
        }}
      >
        <Box mb={"100px"}><Heading color={"#121212"}>찾아오시는 길</Heading></Box>
        <Box 
          w={"100%"} 
          h={screen !== "pc" ? "100%" : "25vw"} 
          minH={screen !== "pc" ? "100%" : "320px"}
          display={"flex"} 
          justifyContent={"space-evenly"}
          flexDir={screen !== "pc" ? "column" : "row"}
        >
          {screen === "pc" ?
            <Box w={"40vw"} h={"100%"}>
              <Stack 
                w={"100%"} 
                h={"100%"} 
                gap={0}
                borderTop={"1px solid #121212"} 
                borderBottom={"1px solid #121212"}
              >
                {mapList?.map((map, index) => {
                  return (
                    <Stack 
                      key={index}
                      w={"100%"}
                      h={"100%"}
                      p={"20px 0"}
                      flex={1}
                      borderTop={"1px solid #121212"} 
                      borderBottom={"1px solid #121212"}
                      justifyContent={'space-between'}
                      onClick={() => _setMapId(index)}
                      cursor={"pointer"}
                    >
                      <Box display={"flex"} alignItems={"center"}>
                        <Heading as={"h3"} color={mapId === index ? "#121212" : "#969696"} fontSize={convertFontSize(26, 36)}>{map.name}</Heading>
                        {mapId === index && <IconNext />}
                      </Box>
                      <Text fontSize={"14px"} color={mapId === index ? "#121212" : "#969696"} whiteSpace={"pre-wrap"}>
                        {map.address.replace(" (", `\n(`)}
                      </Text>
                      <Box display={"flex"} justifyContent={"space-between"}>
                        <Text display={"flex"} fontSize={"14px"} color={mapId === index ? "#121212" : "#969696"}><IPhone $isselect={(mapId === index).toString()} />{map.tel}</Text>
                        <Text display={"flex"} fontSize={"14px"} color={mapId === index ? "#121212" : "#969696"}><IMail $isselect={(mapId === index).toString()} />{map.email}</Text>
                      </Box>
                    </Stack>
                  )
                })}
              </Stack>
            </Box>
          :
            <Box w={"100%"} display={"flex"} border={"1px solid #D9D9D9"}>
              {mapList?.map((map, index) => {
                return (
                  <Box 
                    key={index} 
                    display={"flex"} 
                    justifyContent={"center"}
                    alignItems={"center"} 
                    flex={1} 
                    padding={"3%"}
                    backgroundColor={mapId === index ? "#333333" : "transparent"}
                    cursor={"pointer"}
                    onClick={() => _setMapId(index)}
                  >
                    <Text fontWeight={600} color={mapId === index ? "#ffffff" : "#D9D9D9"}>{map.name}</Text>
                  </Box>
                )
              })}
            </Box>
          }
          <Box position={"relative"} width={screen !== "pc" ? "100%" : "40vw"} height={"100%"} mb={"5%"}>
            <Box id="map" width={screen !== "pc" ? "calc(100vw - 11%)" : "100%"} height={screen !== "pc" ? screen === "tablet" ? "50vw" : "80vw" : "100%"}></Box>
            <Box position={"absolute"} right={"5%"} bottom={"5%"} zIndex={100}>
              <ImgLogo onClick={handleMove} />
            </Box>
          </Box>
          {screen !== "pc" &&
            <Stack 
              w={"100%"}
              h={"100%"}
              p={"5%"}
              borderTop={"1px solid #D9D9D9"} 
              borderBottom={"1px solid #D9D9D9"}
              justifyContent={'space-between'}
            >
              <Text fontSize={"14px"} color={"#121212"} marginBottom={"3%"}>{mapList[mapId].address}</Text>
              <Text display={"flex"} fontSize={"14px"} color={"#121212"}><IPhone $isselect={"true"} />{mapList[mapId].tel}</Text>
              <Text display={"flex"} fontSize={"14px"} color={"#121212"}><IMail $isselect={"true"} />{mapList[mapId].email}</Text>
            </Stack>
          }
        </Box>
      </Container>
    </Info>
  );
};

export default Information;